import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import ScrollToTop from "@/components/ScrollToTop";
import PoliticsPage from "@/pages/PoliticsPage";
import AgenciesPage from "@/pages/AgenciesPage";
import PartnersDirectory from "@/pages/PartnersDirectory";
import PartnerProfile from "@/pages/PartnerProfile";
import SaasPage from "@/pages/SaasPage";
import CampaignsPage from "@/pages/CampaignsPage";
import AgentesPage from "@/pages/AgentesPage";

// Admin
import { AuthProvider } from "@/admin/AuthContext";
import AuthCallback from "@/admin/AuthCallback";
import ProtectedRoute from "@/admin/ProtectedRoute";
import AdminLogin from "@/admin/pages/AdminLogin";
import AdminDashboard from "@/admin/pages/AdminDashboard";
import AdminProfile from "@/admin/pages/AdminProfile";
import { AdminPartnersList, AdminPartnerEdit } from "@/admin/pages/AdminPartners";
import AdminLeads from "@/admin/pages/AdminLeads";
import AdminPrivacy from "@/admin/pages/AdminPrivacy";
import PrivacyPage from "@/pages/PrivacyPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Navigate to="/politics" replace />} />
            <Route path="/politics" element={<PoliticsPage />} />
            <Route path="/politics/agencies" element={<AgenciesPage />} />
            <Route path="/politics/parceiros" element={<PartnersDirectory />} />
            <Route path="/politics/parceiros/:slug" element={<PartnerProfile />} />
            <Route path="/saas" element={<SaasPage />} />
            <Route path="/campanhas" element={<CampaignsPage />} />
            <Route path="/agentes" element={<AgentesPage />} />
            <Route path="/privacidade" element={<PrivacyPage />} />

            {/* Admin */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/auth/google" element={<AuthCallback />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/perfil"
              element={
                <ProtectedRoute>
                  <AdminProfile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/parceiros"
              element={
                <ProtectedRoute requireAdmin>
                  <AdminPartnersList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/parceiros/:slug"
              element={
                <ProtectedRoute requireAdmin>
                  <AdminPartnerEdit />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/leads"
              element={
                <ProtectedRoute requireAdmin>
                  <AdminLeads />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/privacidade"
              element={
                <ProtectedRoute requireAdmin>
                  <AdminPrivacy />
                </ProtectedRoute>
              }
            />

            <Route path="*" element={<Navigate to="/politics" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: "#1B1D1D",
            color: "#F5FAFB",
            border: "1px solid rgba(255,255,255,0.08)",
          },
        }}
      />
    </div>
  );
}

export default App;
